import { render, staticRenderFns } from "./LeaveMotivation.vue?vue&type=template&id=60eba6d5&scoped=true&"
import script from "./LeaveMotivation.vue?vue&type=script&lang=js&"
export * from "./LeaveMotivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eba6d5",
  null
  
)

export default component.exports